import $ from 'jquery';
import validate from 'jquery-validation';


// ---- CONTACT FORM PRISMIC
class ContactFormPrismic {
  constructor(form) {
    this.form = form;
    this.form.on('submit', function (e) {
      e.preventDefault();
      validateForm(validateField);
      return false;
    });
    const that = this;
    this.getInputs().change(function () {
      that.startCallback && that.startCallback(that.form);
    });
    this.form.validate({
      messages: this.getValidationMessagesFix(),
      submitHandler: function (form) { that.submit(); }
    });
  }

  defaultParams(func) {
    this.getDefaultParams = func;
    return this;
  }

  // func params -> (data, url)
  done(func) {
    this.doneCallback = func;
    return this;
  }

  // func params -> (data, url)
  fail(func) {
    this.failCallback = func;
    return this;
  }

  start(func) {
    this.startCallback = func;
    return this;
  }

  toggleLoading() {
    this.form.find('.loader').toggleClass('hidden');
  }

  submit() {
    this.lockForm();
    const request = $.ajax({
      url: this.getRequestUrl(),
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(this.getRequestData()),
      success: this.handleSuccess.bind(this),
      error: this.handleError.bind(this)
    });
    if (this.failCallback) { request.fail(this.failCallback); }
  }

  handleSuccess(data) {
    const sentData = this.getRequestData();
    this.unlockForm();
    this.form.find('input:visible, select:visible, textarea:visible').val('');
    const url = data.success_page_url || this.getRequestUrl();
    if (this.doneCallback) {
      const skipRedirection = this.doneCallback(this.form, data, url, sentData);
      if (skipRedirection) {
        return;
      }
    }
    window.location.href = url;
  }

  handleError(data) {
    const sentData = this.getRequestData();
    this.unlockForm();
    this.failCallback && this.failCallback(this.form, data, sentData);
  }

  lockForm() {
    this.toggleLoading();
    this.getInputs().attr('disabled', 'disabled');
    this.form.find('button[type="submit"]').attr('disabled', 'disabled');
  }

  unlockForm() {
    this.toggleLoading();
    this.form.find('button[type="submit"]').removeAttr('disabled');
    this.getInputs().removeAttr('disabled');
  }

  getInputs() { return this.form.find('input, select, textarea'); }
  getRequestUrl() { return this.form.attr('action'); }
  getRequestData() {
    let data = {};
    if (this.getDefaultParams) { data = this.getDefaultParams(); }
    this.getInputs().each(function () {
      let key = $(this).attr('id');
      if (!key) { console.log('Form: input missing id', $(this)); }
      key = key || $(this).attr('name'); // second chance for CSRF token
      data[key] = $(this).val();
    });
    return data;
  }

  getValidationSymbolMessage() {
    return this.form.find('.invalid-icon').html();
  }

  getValidationMessagesFix() {
    const value = this.getValidationSymbolMessage();
    const messages = {};
    this.getInputs().each(function () {
      messages[$(this).attr('name')] = value;
    });
    return messages;
  }
}

document.addEventListener('DOMContentLoaded', function (event) {
  const $formBuilder = $('.contact-form-prismic');
  const $floatingSelect = $('.js-floating-select');

  if ($formBuilder.length) {
    if (window && window.analytics) {
      window.analytics.track('website_' + $formBuilder.data('tracking-event') + '_form_entered');
    }

    new ContactFormPrismic($formBuilder).defaultParams(function () {
      return {
        source: getUrlParameter('source'),
        anonymous_id: getAnonymousId(),
        sf_lead: true,
        location: $formBuilder.data('location')
      };
    }).done(function (form, response, url, data) {
      if (response.captcha_failed) {
        // Cf. app/controllers/forms_controller.rb
        console.log('We have been spammed by a bot');
        return true;
      }

      if (window && window.analytics) {
        let properties = {
          page_url: window.location.href,
          location: $formBuilder.data('location'),
          website_locale: response.locale,
          source: getUrlParameter('source'),
          user_ga_id: getGaId(),
          id_tools_synch: getHash(),
          gdpr_consent_status: getDidomiCookieConsent()
        };

        if (response.segment && response.segment.properties) {
          properties = $.extend(properties, response.segment.properties);
        }

        window.analytics.track('website_' + $formBuilder.data('tracking-event') + '_form_submitted', properties);
      }

      if (response.redirect_to) {
        window.location.href = response.redirect_to;
      } else {
        $formBuilder.addClass('status--success');
        setInterval(function () {
          $formBuilder.removeClass('status--success');
        }, 5000);
      }

      return true;
    }).fail(function (form, response, data) {
      $formBuilder.addClass('status--error');
      setInterval(function () {
        $formBuilder.removeClass('status--error');
      }, 10000);
    });
  }
  if ($floatingSelect.length) {
    $floatingSelect.on('change', function () {
      this.setAttribute('value', this.value);
    });
    $floatingSelect.each(function () {
      const $selected = $(this).find(':selected');
      this.setAttribute('value', this.value);

      if ($selected.val() === '') {
        $selected.html('');
      }
    });
  }
  toggleCapitalDepositFields();
});

const validateEmail = (email) => {
  return email.match(/(.+)@(.+){2,}\.(.+){2,}/)?.length > 0;
};

const validateField = (element, field) => {
  const errorMessage = field.querySelector('.error-message');
  if (element.required && element.value === '') {
    errorMessage.style.display = 'block';
  } else if (element.type === 'email' && !validateEmail(element.value)) {
    errorMessage.style.display = 'block';
  } else {
    errorMessage.style.display = '';
  }
};

const validateFieldsOnChange = (input, field) => {
  input.addEventListener('change', event => {
    const element = event.target;
    validateField(element, field);
  });
};

const validateForm = (validateMethod) => {
  const fields = form.querySelectorAll('.field:not(.hidden)');

  fields.forEach(field => {
    const input = field.querySelector('input') || field.querySelector('select');
    validateMethod(input, field);
  });
};

const form = document.querySelector('.form-hero-section .form');
if (form) {
  validateForm(validateFieldsOnChange);
}

const toggleCapitalDepositFields = () => {
  const capitalDeposit = $('#capital_deposit');
  capitalDeposit.on('change', () => {
    const company = $('#company');
    const nbEmployees = $('#nb_employees');
    const onRecommendForm = window.location.pathname.includes('recommend');
    if (capitalDeposit.val() === 'true' ) {
      nbEmployees.val('0');
      nbEmployees.parent().parent().hide();
      if (!onRecommendForm) {
        company.val('unknown');
        company.parent().parent().hide();
       }
    } else {
      if (!onRecommendForm) { company.val(''); }
      company.parent().parent().show();
      nbEmployees.parent().parent().show();
    }
  })
}
